export default __webpack_public_path__ + "static/media/program-4.43121c15.jpg";